import { PawPrint, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useTranslation } from '@/i18n';
import type { DropdownMenuItem } from '@/components/ui';

export function useCreateEntityMenuItems(onSelect?: () => void): DropdownMenuItem[] {
  const navigate = useNavigate();
  const t = useTranslation();
  const go = (to: string, state?: Record<string, unknown>) => {
    onSelect?.();
    navigate(to, state ? { state } : undefined);
  };
  return [
    { icon: <UserRound size={16} aria-hidden="true" />, label: t('companion.create.character'), description: t('companion.create.characterHint'), onSelect: () => go('/create', { fresh: true }) },
    { icon: <PawPrint size={16} aria-hidden="true" />, label: t('companion.create.creature'), description: t('companion.create.creatureHint'), onSelect: () => go('/companions/new') },
  ];
}
